module.exports = __webpack_public_path__ + "assets/SquareInTriangleDetailed.1eb4042cbf4871e3e95df167a09d26c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/SquareInTriangleDetailed.png
// module id = 570
// module chunks = 0